<div *ngIf="!isMediaCard">
  <svg-icon
    *ngIf="category"
    [src]="'assets/card-images/' + iconFolder + '/' + iconPrefix + category + '.svg'"
    class="category-icon"
    [ngClass]="iconColorClass"
  ></svg-icon>
</div>
<div *ngIf="isMediaCard" class="media">
  <i [class]="'fa-3x ' + mediaIcon"></i>
</div>
